import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const SESSION_KEY = 'mobu_privacy_mode';

interface PrivacyContextValue {
  isPrivacy:     boolean;
  togglePrivacy: () => void;
}

const PrivacyCtx = createContext<PrivacyContextValue>({
  isPrivacy:     true,
  togglePrivacy: () => {},
});

export function PrivacyProvider({ children }: { children: React.ReactNode }) {
  const [isPrivacy, setIsPrivacy] = useState<boolean>(() => {
    const saved = sessionStorage.getItem(SESSION_KEY);
    return saved === null ? true : saved === 'true';
  });

  // Sync trạng thái vào body class — CSS xử lý blur toàn cục
  useEffect(() => {
    document.body.classList.toggle('privacy-mode', isPrivacy);
  }, [isPrivacy]);

  // Áp dụng ngay lần đầu mount
  useEffect(() => {
    document.body.classList.toggle('privacy-mode', isPrivacy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const togglePrivacy = useCallback(() => {
    setIsPrivacy(prev => {
      const next = !prev;
      sessionStorage.setItem(SESSION_KEY, String(next));
      return next;
    });
  }, []);

  return (
    <PrivacyCtx.Provider value={{ isPrivacy, togglePrivacy }}>
      {children}
    </PrivacyCtx.Provider>
  );
}

export function usePrivacy(): PrivacyContextValue {
  return useContext(PrivacyCtx);
}
